export default __webpack_public_path__ + "static/media/youtube-white.e6cee99b.svg";